import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/nav_logo.png";
import codeOne from "../../assets/scancode-1.jpg";
import codeTwo from "../../assets/scancode-2.png";

export const FooterBrand = ({ homePath, qr1, qr2 }) => (
  <div className="footer-brand">
    <Link to={homePath}>
      <div className="footer-brand__logo">
        <img src={logo} alt="Company Logo" />
      </div>
    </Link>
    <div className="footer-brand__qr flex">
      <div className="footer-brand__code">
        <div className="footer-brand__code-in">
          <img src={codeOne} alt="QR Code 1" />
        </div>
        <p>{qr1}</p>
      </div>
      <div className="footer-brand__code">
        <div className="footer-brand__code-in">
          <img src={codeTwo} alt="QR Code 2" />
        </div>
        <p>{qr2}</p>
      </div>
    </div>
  </div>
);

export const FooterContact = ({ copy, contactInfo }) => (
  <div className="footer-contact">
    <h5>{copy.contactTitle}</h5>
    <div className="footer-contact__message">
      <div className="footer-contact__line">
        <span className="footer-contact__name">{copy.mainLine}</span> :{" "}
        {contactInfo?.msg5}
      </div>
      <div className="footer-contact__line">
        <span className="footer-contact__name">{copy.afterSales}</span> :{" "}
        {contactInfo?.msg4}
      </div>
      <div className="footer-contact__line">
        <span className="footer-contact__name">{copy.fax}</span> :{" "}
        {contactInfo?.msg6}
      </div>
      {copy.WhatsApp && (
        <div className="footer-contact__line">
          <span className="footer-contact__name">{copy.WhatsApp}</span> : +86
          13929269883
        </div>
      )}
    </div>
  </div>
);

export const FooterCopyright = ({ copy }) => (
  <div className="footer-copyright flex">
    <div className="footer-copyright__item">{copy.copyright}</div>
    <div className="footer-copyright__item">
      <Link target="_blank" to="http://beian.miit.gov.cn/">
        {copy.icp}
      </Link>
    </div>
    <div className="footer-copyright__item">
      <Link
        target="_blank"
        to="http://beian.miit.gov.cn/portal/registerSystemInfo?recordcode=44011602000125"
      >
        {copy.psb}
      </Link>
    </div>
  </div>
);
